import Vuex from 'vuex'
import {actions, getters, mutations, state} from './comum'
import fileManager from './fileManager'
import usuario from './usuario'
import menu from './menu'
import cidade from './cadastros/cidade'
import estado from './cadastros/estado'
import paciente from './cadastros/paciente'
import ficha from './cadastros/ficha'
import odontograma from './odontograma'
import relatorios from './relatorios'
import perfil from './perfil'
import perfilPermissao from './perfilPermissao'
import perfilUsuario from './perfilUsuario'
import cobranca from './cobranca'
import pagamento from './pagamentos'
import salaEspera from './salaEspera'
import agenda from './agenda'
import atendimento from './atendimento'
import configuracao from './configuracao'
import inicio from './inicio'
import servico from './servico'
import servicoAtendimento from './servicoAtendimento'
import servicoOrcamento from './servicoOrcamento'
import orcamento from './orcamento'
import galeria from './galeria'

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        fileManager,
        usuario,
        menu,
        cidade,
        estado,
        paciente,
        ficha,
        odontograma,
        relatorios,
        perfil,
        perfilPermissao,
        perfilUsuario,
        cobranca,
        pagamento,
        salaEspera,
        agenda,
        atendimento,
        configuracao,
        inicio,
        servico,
        servicoAtendimento,
        servicoOrcamento,
        orcamento,
        galeria
    }
})
